import '../css/style.css';
import 'flowbite/dist/flowbite.js';
import './sidebar';
import './charts';
import './tom-select';
import './dark-mode';
import './simple-datatables';
// import './documentos-table';

// código para datatables
if (document.getElementById("default-table") && typeof simpleDatatables.DataTable !== 'undefined') {
    const dataTable = new simpleDatatables.DataTable("#default-table", {
        searchable: false,
        perPageSelect: false
    });
}
